import { render, staticRenderFns } from "./PreviewArticle.vue?vue&type=template&id=9fd6704a"
import script from "./PreviewArticle.vue?vue&type=script&lang=js"
export * from "./PreviewArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports